export default __webpack_public_path__ + "static/media/wdl-logo.0242f2d1.png";